module.exports = __webpack_public_path__ + "static/img/yxhd.a18c989d.png";